import { useQuery } from "@tanstack/react-query";
import api from "../../api/apiClient";
import { StoreActionDetails } from "../../types/modules/store/StoreActionDetails.type";

export const useStoreDetailsByOwner = (storeId: number, enabled: boolean = true) => {
    return useQuery({
        queryKey: ["owner-store-details", storeId],
        queryFn: () =>
            api.get<StoreActionDetails>(`store/action/current?storeId=${storeId}`).then(res => res.data),
        enabled: enabled && !!storeId,
    });
};
